import { render, staticRenderFns } from "./DowngradeModal.vue?vue&type=template&id=4b470bdb"
import script from "./DowngradeModal.vue?vue&type=script&lang=js"
export * from "./DowngradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports